import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/50u4k8b4_Trustar%20Logo%20H.png" 
              alt="Trustar" 
              className="h-10 mb-4 brightness-0 invert"
            />
            <p className="text-sm leading-relaxed">
              {companyInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/products/tinergy" className="text-sm hover:text-white transition-colors">Tinergy</Link></li>
              <li><Link to="/products/titax" className="text-sm hover:text-white transition-colors">Titax</Link></li>
              <li><Link to="/products/albalux" className="text-sm hover:text-white transition-colors">Albalux</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Mail size={18} className="mr-2 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${companyInfo.contact.email}`} className="text-sm hover:text-white transition-colors">
                  {companyInfo.contact.email}
                </a>
              </li>
              <li className="flex items-start">
                <Phone size={18} className="mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{companyInfo.contact.phone}</span>
              </li>
              <li className="flex items-start">
                <MapPin size={18} className="mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  {companyInfo.address.city}, {companyInfo.address.country}
                </span>
              </li>
            </ul>
          </div>

          {/* Legal Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <p className="text-sm leading-relaxed">
              {companyInfo.legalName}<br />
              {companyInfo.address.line1}<br />
              {companyInfo.address.line2}<br />
              {companyInfo.address.line3}<br />
              {companyInfo.address.poBox}<br />
              {companyInfo.address.city}, {companyInfo.address.country}
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} {companyInfo.legalName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
